module.exports = __webpack_public_path__ + "static/media/favebiz-payment.fb542fd8.jpg";